export type Chemical = {
  id: string;
  name: string;
  price: number;
  measuringUnit: string;
};

export type MeasuringUnit = 'imperial' | 'metric';

export const MeasuringUnitDisplay = {
  metric: 'Metric (L, ml, kg, kPa)',
  imperial: 'Imperial (gal, lbs, oz, psi)',
};

export type ApiResponse<T> =
  | { data: T; error?: string }
  | { data?: T; error: string };
